"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tfoot = exports.Tbh = exports.Th = exports.Td = exports.Tr = exports.Tbody = exports.Thead = exports.Table = void 0;

var _themeOptimized = _interopRequireDefault(require("../themeOptimized"));

var _table = _interopRequireDefault(require("./views/table"));

var _thead = _interopRequireDefault(require("./views/thead"));

var _tbody = _interopRequireDefault(require("./views/tbody"));

var _tr = _interopRequireDefault(require("./views/tr"));

var _td = _interopRequireDefault(require("./views/td"));

var _th = _interopRequireDefault(require("./views/th"));

var _tbh = _interopRequireDefault(require("./views/tbh"));

var _tfoot = _interopRequireDefault(require("./views/tfoot"));

var Table = (0, _themeOptimized["default"])(_table["default"], 'table');
exports.Table = Table;
var Thead = (0, _themeOptimized["default"])(_thead["default"], 'table');
exports.Thead = Thead;
var Tbody = (0, _themeOptimized["default"])(_tbody["default"], 'table');
exports.Tbody = Tbody;
var Tr = (0, _themeOptimized["default"])(_tr["default"], 'table');
exports.Tr = Tr;
var Td = (0, _themeOptimized["default"])(_td["default"], 'table');
exports.Td = Td;
var Th = (0, _themeOptimized["default"])(_th["default"], 'table');
exports.Th = Th;
var Tbh = (0, _themeOptimized["default"])(_tbh["default"], 'table');
exports.Tbh = Tbh;
var Tfoot = (0, _themeOptimized["default"])(_tfoot["default"], 'table');
exports.Tfoot = Tfoot;